import { render, staticRenderFns } from "./addRemarks.vue?vue&type=template&id=9fdbea16&"
import script from "./addRemarks.vue?vue&type=script&lang=js&"
export * from "./addRemarks.vue?vue&type=script&lang=js&"
import style0 from "./addRemarks.vue?vue&type=style&index=0&id=9fdbea16&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports